<<!--  -->
<template>
  <div class="text-l fz-14 default">
    <div v-if="type==1">
      <el-row class="fz-14 c-000 mt-24 mb-20">重要提醒：</el-row>
      <el-row class="c-666 line-22">1.务必确保信息准确无误再提交，任何一项错误，直接拒绝！</el-row>
      <el-row class="c-666 line-22">2.请确保已经和商家对接清楚，中途不支持调整价格和佣金！</el-row>
      <el-row class="c-666 line-22">3.若中途商品有变化，请及时下架商品！</el-row>
      <el-row class="c-666 line-22">4.不建议提报三天内价格未变动的商品。</el-row>
      <el-row class="c-666 line-22">5.发布主图清晰清爽不能附带牛皮癣和价格，咨询客服，返现等文字（被举报会被系统下架商品）。</el-row>

      <el-row class="c-666 line-22 mt-10 fz-14">
        <span>您今日可提报总数为10条，剩余</span>
        <span class="c-e53 bold">{{suplus}}</span>条。
      </el-row>
      <el-row>
        <el-row class="fz-14 bold c-000 mt-24 mb-20">提报单品</el-row>
          <el-row>
            <el-steps simple :active="0">
              <el-step title="提报单品" icon="el-icon-circle-check"></el-step>
              <el-step title="单品人工审核" icon="el-icon-circle-check"></el-step>
              <el-step title="上架到星罗" icon="el-icon-circle-check"></el-step>
              <el-step title="同步到什么值得买" icon="el-icon-circle-check"></el-step>
            </el-steps>
          </el-row>
      </el-row>
      

    </div>
    <el-row>
      <el-col :span="24" class="fz-14 c-000 mt-24 mb-20">
        <span>提报详情：</span>
      </el-col>
    </el-row>


<div class='w-1136 over-hid'>
    <el-row>
      <el-col :span="24" class="line-40 mb-20">
        <el-col :span="3" class="flex-end">
          <span class="c-e53 fz-14 ml-4">*</span>
          <span class="c-606 fz-14">商品链接：</span>
        </el-col>
        <el-col :span="11">
          <el-input v-model="tao_url" size='large' :disabled="type==2" placeholder="请输入商品链接" clearable></el-input>
        </el-col>
        <el-col :span="3">
          <el-button type="primary" class="ml-16" size='large' @click="getGoods">获取信息</el-button>
        </el-col>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24" class="line-40 mb-20">
        <el-col :span="3" class="flex-end">
          <span class="c-e53 fz-14 ml-4">*</span>
          <span class="c-606 fz-14">商品分类：</span>
        </el-col>
        <el-col :span="4">
          <el-select v-model="smzdm_category_1" @change="categoryLeft($event,1,1)" size='large'>
            <el-option
              v-for="item in smzdm_list_1"
              :key="item.smgscyid"
              :label="item.name"
              :value="item.smgscyid"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="4" class="ml-25">
          <el-select v-model="smzdm_category_2" @change="categoryLeft($event,2,1)" size='large'>
            <el-option
              v-for="item in smzdm_list_2"
              :key="item.smgscyid"
              :label="item.name"
              :value="item.smgscyid"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="4" class="ml-25">
          <el-select v-model="smzdm_category_3" size='large'>
            <el-option
              v-for="item in smzdm_list_3"
              :key="item.smgscyid"
              :label="item.name"
              :value="item.smgscyid"
            ></el-option>
          </el-select>
        </el-col>
      </el-col>
    </el-row>



    <el-row>
      <el-col :span="24" class="line-40 mb-20">
        <el-col :span="3" class="flex-end">
          <span class="c-e53 fz-14 ml-4 opacity">*</span>
          <span class="c-606 fz-14">商品品牌：</span>
        </el-col>
        <el-col :span="11">
          <el-input v-model="brand" placeholder="请输入商品品牌" clearable size='large'></el-input>
        </el-col>
      </el-col>
    </el-row>

    <el-row class="mb-20">
      <el-col :span="24" class="line-40">
        <el-col :span="3" class="flex-end">
          <span class="c-e53 fz-14 ml-4">*</span>
          <span class="c-606 fz-14">商品标题：</span>
        </el-col>
        <el-col :span="11">
          <el-input v-model="goods_title" type="text" placeholder="请输入商品标题" clearable size='large'></el-input>
        </el-col>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24" class="line-40 mb-5">
        <el-col :span="3" class="flex-end">
          <span class="c-e53 fz-14 ml-4">*</span>
          <span class="c-606 fz-14">推广短标题：</span>
        </el-col>
        <el-col :span="11">
          <el-input
          size='large'
            v-model="short_extension_title"
            placeholder="10-16字的精简优质短标题，切勿堆砌重复关键词"
            maxlength="16"
            clearable
          ></el-input>
        </el-col>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="line-18 mb-10">
      <el-col :offset="3" :span="17" class="c-c1c">
        还可输入
        <span class="c-e53" v-html="shortfont"></span>个字
      </el-col>
    </el-row>
    <!-- //图片上传 -->
    <el-row>
      <el-col :span="24" class="mb-20">
        <el-col :span="3" class="line-22 flex-end">
          <span class="c-e53 fz-14 ml-4">*</span>
          <span class="c-606 fz-14">商品图片：</span>
        </el-col>
        <el-col :span="13" class="up-img pos-r">
          <span class="line-22 c-c1c">请上传清晰的白底正方形商品图，400*400以上</span>

          <el-upload
            accept="image/gif, image/jpeg, image/png, image/jpg"
            :action="api.upload_img"
            name="filename"
            :file-list="file_list"
            :before-upload="fileBefore"
            :on-success="fileSuccess"
            :on-remove="handleRemove"
            :on-preview="handlePictureCardPreview"
            :on-error="fileErr"
            list-type="picture-card"
            :limit="1"
            :on-exceed="fileExceed"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible" size="tiny">
            <img width="100%" :src="dialogImageUrl" alt>
          </el-dialog>
        </el-col>
      </el-col>
    </el-row>

   

    <el-row>
      <el-col :span="24" class="line-40 mb-10">
        <el-col :span="3" class="flex-end">
          <span class="c-e53 fz-14 ml-4">*</span>
          <span class="c-606 fz-14">是否包邮：</span>
        </el-col>
        <el-col :span="11">
          <el-checkbox v-model="baoyou">
            <span class="c-606 normal hover-b">包邮</span>
          </el-checkbox>
        </el-col>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24" class="line-40 mb-20">
        <el-col :span="3" class="flex-end">
          <span class="c-e53 fz-14 ml-4">*</span>
          <span class="c-606 fz-14">商品库存：</span>
        </el-col>
        <el-col :span="11" id="kucun" class="kucun">
          <el-input v-model="stock" min="1" type="number" placeholder="参与此次优惠的商品库存" size='large'></el-input>
        </el-col>
      </el-col>
    </el-row>


    <el-row>
      <el-col :span="24" class="line-40 mb-5">
        <el-col :span="3" class="flex-end">
          <span class="c-e53 fz-14 ml-4">*</span>
          <span class="c-606 fz-14">推荐理由：</span>
        </el-col>
        <el-col :span="13" class="flex-bw">
          <span>价格优势</span>
          <div class="mr-9">最少输入7个字</div>
        </el-col>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :offset="3" :span="13" class="mb-5" style='padding-right:0;'>
        <el-input
          size='large'
          class='sub'
          type="textarea"
          :rows="4"
          placeholder="请分享得到此优惠价格的方法，并描述优惠力度，新手可以参照万能模版"
          v-model="advantage"
        ></el-input>
      </el-col>
    </el-row>
    <el-row :gutter="19">
      <el-col :span="16" class="line-22 mb-20 flex-end">
        <el-checkbox v-model="wanoff" class="flex-al" size='large' @change="getWanneng">
          <span class="normal fz-14 hover-r">引入万能模版</span>
        </el-checkbox>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :offset="3" :span="13" class="flex-bw mb-10">
        <span>商品优势</span>
        <div>最少输入7个字</div>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :offset="3" :span="13" class="mb-5 " style='padding-right:0;'>
        <el-input
          size='large'
          type="textarea"
          :rows="4"
          placeholder="请详细描述您的单品卖点，如品牌优势、产品定位、主要功能点及优势点、产品的规格数、售卖服务等相关信息。"
          v-model="goods_advantage"
        ></el-input>
      </el-col>
    </el-row>

    
    <el-row :gutter="20">
      <!-- <el-button v-popover:popover1>hover 激活</el-button> -->
      <el-popover ref="popover1" placement="top" title="示例" width="400" trigger="hover">
        <slot>
          <div class="fz-14 line-16 mb-20">
            案例①：针对头发稀少，细软和扁塌的亲们而设计的，含有维生素、咖啡因、牛蒡根和透明质酸，促进头部血液循环。用后明显增发，脱发减少，头发变得不再油腻，可以在4个月里增长大约13%的头发。使用方式：在洗干净的头发上，取适量发膜抹至头皮上按摩片刻,停留10-15分钟后冲洗掉。不能用在眉毛和睫毛上。 天猫售价129元，加上运费实付179元到手。国内代购价格在149-299元之间，美亚27.4美元左右，天猫保真又有价格优势。
            案例②：单买好价，送镜片~ 此款Ray·Ban雷朋ORX6281D金属眼镜架采用合金材质，方形半框包围款式，搭配同材质镜腿，且镜腿处有金属LOGO，文雅大方。此款有棕色、枪灰色可选，款式很适合商务人士佩戴。规格：宽度140mmm，镜腿145mm，重量15g。 可得眼镜网目前雷朋 6281D黑色、枪灰色两款售价259元，购买即送赠送1.60非球面树脂镜片（0-800度），可使用20元优惠券，下单实付239元包邮，上次推荐没买到的这次可以入了~
          </div>
          <div
            class="fz-14 line-16 mb-20"
          >案例②：单买好价，送镜片~ 此款Ray·Ban雷朋ORX6281D金属眼镜架采用合金材质，方形半框包围款式，搭配同材质镜腿，且镜腿处有金属LOGO，文雅大方。此款有棕色、枪灰色可选，款式很适合商务人士佩戴。规格：宽度140mmm，镜腿145mm，重量15g。 可得眼镜网目前雷朋 6281D黑色、枪灰色两款售价259元，购买即送赠送1.60非球面树脂镜片（0-800度），可使用20元优惠券，下单实付239元包邮，上次推荐没买到的这次可以入了~</div>
        </slot>
      </el-popover>
      <el-col :span="16" class="line-22 mb-20 flex-end pointer">
        <span v-popover:popover1 class="hover-r">商品优势示例</span>
      </el-col>
    </el-row>

    <!-- 优惠信息 -->
    <el-row class="fz-14 c-000 mb-20 bold">优惠信息：</el-row>


    <el-row>
      <el-row>
        <el-col :span="24" class="line-40 mb-20">
          <el-col :span="3" class="flex-end">
            <!-- <span class="c-e53 fz-14 ml-4">*</span> -->
            <span class="c-606 fz-14">优惠券链接：</span>
          </el-col>
          <el-col :span="11">
            <el-input v-model="coupon_url" placeholder="请输入优惠券链接" clearable size='large'></el-input>
          </el-col>
          <el-col :span="3">
            <el-button type="primary" class="ml-16" @click="getCoupon" size='large'>获取信息</el-button>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24" class="line-40 mb-20">
          <el-col :span="3" class="flex-end">
            <span class="c-e53 fz-14 ml-4" v-if="xingshow">*</span>
            <span class="c-606 fz-14">优惠券生效时间：</span>
          </el-col>
          <el-col :span="20">
            <el-date-picker
              disabled
              v-model="coupon_start_time"
              type="date"
              placeholder="选择优惠券开始时间"
              style="width:200px;"
              size='large'
            ></el-date-picker>
            <span class="ml-4 mr-4">至</span>
            <el-date-picker
              disabled
              v-model="coupon_end_time"
              type="date"
              placeholder="选择优惠券结束时间"
              style="width:200px;"
              size='large'
            ></el-date-picker>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24" class="line-40 mb-20">
          <el-col :span="3" class="flex-end">
            <span class="c-e53 fz-14 ml-4" v-if="xingshow">*</span>
            <span class="c-606 fz-14">优惠券总量：</span>
          </el-col>
          <el-col :span="11">
            <el-input disabled type="number" placeholder="优惠券总量" v-model="coupon_total_count" size='large'></el-input>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24" class="line-40 mb-20">
          <el-col :span="3" class="flex-end">
            <span class="c-e53 fz-14 ml-4" v-if="xingshow">*</span>
            <span class="c-606 fz-14">优惠券剩余数量：</span>
          </el-col>
          <el-col :span="11">
            <el-input disabled type="number" placeholder="优惠券剩余数量" v-model="coupon_remain_count" size='large'></el-input>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24" class="line-40 mb-20">
          <el-col :span="3" class="flex-end">
            <span class="c-e53 fz-14 ml-4" v-if="xingshow">*</span>
            <span class="c-606 fz-14">优惠券金额：</span>
          </el-col>
          <el-col :span="11">
            <el-input disabled placeholder="优惠券金额" v-model="coupon_amount" size='large'></el-input>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24" class="line-40 mb-20">
          <el-col :span="3" class="flex-end">
            <span class="c-e53 fz-14 ml-4">*</span>
            <span class="c-606 fz-14">优惠后价格：</span>
          </el-col>
          <el-col :span="11">
            <el-input placeholder="优惠后价格" type='number' v-model="price"  class='kucun' size='large'></el-input>
          </el-col>
        </el-col>
      </el-row>
    </el-row>

    <el-row>
      <el-col :span="24" class="line-40 mb-20">
        <el-col :span="3" class="flex-end">
          <span class="c-e53 fz-14 ml-4 opacity">*</span>
          <span class="c-606 fz-14">备注：</span>
        </el-col>
        <el-col :span="11">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="如果有其他需要审核人员了解的信息，请补充在此处。"
            v-model="remark"
            maxlength="200"
            size='large'
          ></el-input>
        </el-col>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="16" class="flex-c">
        <el-button type="primary" @click="createArticle" v-if="type==1" size='large'>立即提报</el-button>
        <el-button type="primary" @click="editArticle" v-if="type==2" size='large'>立即提报</el-button>
        <el-button class="w-80" @click="showLeave" size='large'>取消</el-button>
      </el-col>
    </el-row>
</div>
    <!-- 弹框提示 -->
    <el-dialog title="提示" :visible.sync="showrepeat" width="30%">
      <span>该商品已在平台存在，价格：{{zk_final_price||reserve_price}}元</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="subAgain">重提一个</el-button>
        <el-button @click="subMore">提交更高优惠</el-button>
      </span>
    </el-dialog>
    <!-- 取消保存返回列表页面 -->
    <el-dialog title="提示" :visible.sync="leave" width="30%">
      <span>您正在提报单品，确认放弃正在编辑的内容并离开当前页面？</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="goList">确认</el-button>
        <el-button @click="leave=false">取消</el-button>
      </span>
    </el-dialog>

    <!-- 招商提报已经提报过该商品 -->
    <el-dialog title="提示" :visible.sync="vip_check_merchant" width="30%">
      <span>该店铺已经绑定【{{nickname}}】，确认是否提报？提报后绩效会算给【{{nickname}}】。</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="aginArticle">确认</el-button>
        <el-button @click="vip_check_merchant=false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import "./tool.css";
import util from "../../utils/util";
import cook from "../../utils/http";
import conf from "../../config/api";
export default {
  name: "",
  data() {
    return {
      type: 1, //1添加2修改
      api: {
        getGoodsInfo: "/home/taobaogoods/getGoodsInfo", //获取淘宝商品详情
        getCoupon: "/home/taobaogoods/getCoupon", //湖区优惠券详情
        suplus_num: "/home/user_create_article_everyday_suplus_num", //获取用户的每天提报剩余数量
        create_article: "/home/create_article", //保存提报
        getUserArticleInfo: "/home/getUserArticleInfo", //修改详情
        edit_article: "/home/edit_article", //用户提交修改提报
        upload_img: "", //上传图片
        getList: "/home/SmzdmGoodsCategory/getList" //获取分类列表
      },
      tao_url: "", //淘宝链接
      brand: "", //商品品牌
      short_extension_title: "", //短标题
      shortfont: 16, //短标题可输入数字
      taobao_goods: {
        //淘宝返回的数据
      },
      goods_title: "", //商品比标题
      real_money: "", //优惠后价格
      platform_way: [
        {
          value: "tianmao",
          label: "淘系"
        },
        {
          value: "jingdong",
          label: "京东"
        }
      ],
      platform: "", //来自哪个平台
      store_nick: "", //店铺名称
      seller_id: "", //卖家店铺id
      exclusive_discount: true, //独家优惠
      // coupon_start_time:'',//优惠券开始时间
      // coupon_end_time:'',//优惠券结束时间
      coupon: {}, //id重复 返回的优惠券数据
      zk_final_price: "", //id重复最新优惠价格
      reserve_price: "", //id重复最新优惠价格
      file_list: [], //商品图片列表
      baoyou: true, //是否包邮
      stock: "", //商品库存
      wanneng:
        "此商品目前在（商城/店铺名称）特价至（XXX）元，可参加（XXX满减直降/促销活动/优惠券/秒杀等）活动，属于（刚需可入/近期好价/历史新低），适合（XXX）人群使用，不容错过。", //万能模版
      wanoff: false, //是否引入万能模版
      advantage: "", //价格优势
      goods_advantage: "", //商品优势
      coupon_url: "", //优惠券链接
      coupon_name: "", //优惠券名称
      coupon_name_2: "", //第二张优惠券名称
      coupon_url_2: "", //第二张优惠券链接
      coupon_start_time: "", //优惠券开始时间
      coupon_end_time: "", //优惠券结束时间
      coupon_total_count: "", //优惠券总量
      coupon_remain_count: "", //优惠券剩余数量
      coupon_amount: "", //优惠金额
      price: "", //优惠后价格
      remark: "", //备注信息
      suplus: "", //今日剩余次数
      aeid: "", //修改商品的id
      aectid:"",//文章 article_content表 id
      leave: false, //取消按钮
      once: 1, //禁止二次点击
      goods_img: "", //图片
      showrepeat: false, //检查是否重复
      dialogVisible: false,
      dialogImageUrl: "",
      xingshow: false, //优惠券前面的星星
      coupon_show: false, //是否显示第二张优惠券
      coupon_add: true, //显示第一个加号
      cooperation: "", //合作方式
      coupon_amount: "", //优惠券金额
      cooperation_way: [
        {
          value: 1,
          label: "团长活动"
        },
        {
          value: 2,
          label: "线下结算"
        }
      ],
      user_commission_rate: "", //佣金比例
      settlement_type: "", //结算方式，1按实付金额结算，2按订单量结算
      settlement_way: [
        {
          value: 1,
          label: "按实付金额结算"
        },
        {
          value: 2,
          label: "按订单量结算"
        }
      ],
      settlement_rate: "", //服务费率 （根据settlement_type 为1 时取值 ）
      settlement_free: "", //服务费（根据settlement_type 为2 时取值 ）
      settlement_rate_1: 1, //默认展示请输入服务费率
      smzdm_list_1: [], //下拉分类list
      smzdm_list_2: [], //下拉分类list
      smzdm_list_3: [], //下拉分类list
      smzdm_category_1: "", //商品一级分类
      smzdm_category_2: "", //商品二级分类
      smzdm_category_3: "", //商品三级分类
      check_merchant: 1, //是否是第一次提交
      vip_check_merchant: false, //提示招商已经提报过该商品
      nickname: "" //以及重复的招商人员
    };
  },
  watch: {
    short_extension_title: {
      handler: function() {
        this.shortfont = Number(16) - Number(this.short_extension_title.length);
      },
      deeo: true
    },
    coupon_url: {
      handler: function() {
        if (this.coupon_url) {
          this.xingshow = true;
        } else {
          this.xingshow = false;
        }
      },
      deeo: true
    }
  },
  components: {},
  created() {
    this.api.upload_img =
      conf.api + "home/upload_img?auth_token=" + cook.cookie.get("auth_token");
    //拒绝后进来修改
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
      this.aeid = this.$route.query.aeid;
    }
    this.getSuplus();
    if (this.type == 2) {
      this.editSome();
    }
    //区分普通用户和招商用户
    this.getList(1, 0);
  },
  mounted() {},
  methods: {
    //或许用户的每天提报剩余数量
    getSuplus() {
      let _this = this;
      let data = {};
      this.$http({
        method: "GET",
        url: _this.api.suplus_num,
        params: data
      }).then(res => {
        if (res.code == 1) {
          _this.suplus = res.data.num;
          _this.$forceUpdate();
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    //获取下拉的分类列表
    getList(num, id) {
      let _this = this;
      // debugger
      let data = {
        smgscyid: id
      };
      this.$http({
        method: "GET",
        url: _this.api.getList,
        params: data
      }).then(res => {
        if (res.code == 1) {
          if (num == 1) {
            _this.smzdm_list_1 = res.data.list;
          } else if (num == 2) {
            _this.smzdm_list_2 = res.data.list;
          } else if (num == 3) {
            _this.smzdm_list_3 = res.data.list;
          }
        } else {
          _this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    //左侧第一个下拉框发生改变
    categoryLeft(e, num, change) {
      if (num == 1) {
        this.smzdm_list_2 = []; //下拉分类list
        this.smzdm_list_3 = []; //下拉分类list
        if (change == 1) {
          this.smzdm_category_2 = "";
          this.smzdm_category_3 = "";
        }
        this.getList(2, e);
      } else if (num == 2) {
        this.smzdm_list_3 = []; //下拉分类list
        if (change == 1) {
          this.smzdm_category_3 = "";
        }
        this.getList(3, e);
      }
    },
    //获取商品信息
    getGoods() {
      let _this = this;
      if (this.suplus <= 0 && this.type == 1) {
        this.$message({
          message: "每人每天最多提报10次",
          type: "warning"
        });
        return false;
      }
      if (this.tao_url == "") {
        this.$message({
          message: "商品链接地址不能为空",
          type: "warning"
        });
        return false;
      }
      this.$http({
        method: "POST",
        url: _this.api.getGoodsInfo,
        data: {
          url: encodeURI(this.tao_url)
        }
      }).then(res => {
        if (res.code == 1) {
          if(res.data.taobao_goods.error){
            _this.$message.error("暂时无法获取该商品");
            return false;
          }
          //不能添加otc药物商品
          if(!res.data.db_goods&&!res.data.taobao_goods){
            _this.$message.error('暂无数据，请手动填写')
            return false;
          }
          //医疗器具不能提交
          if (res.data.taobao_goods.cat_name == "OTC药品/医疗器械/计生用品") {
            _this.$message.error("根据相关法律法规，暂不支持提报该商品");
            _this.tao_url = "";
            return false;
          }
          //优先db_goods 然后taobao_goods
          if(res.data.db_goods){
            _this.taobao_goods=res.data.db_goods
          }else if(res.data.taobao_goods){
            _this.taobao_goods=res.data.taobao_goods
          }
          console.log(_this.taobao_goods)
          _this.goods_title = _this.taobao_goods.goods_title||_this.taobao_goods.title;
          _this.goods_advantage=_this.taobao_goods.goods_advantage;//商品优势
          _this.advantage=_this.taobao_goods.money_advantage;//价格优势
          if(_this.taobao_goods.platform!="jingdong"){
              _this.seller_id =_this.taobao_goods.seller_id||_this.taobao_goods.shop_info.user_id;
          }
          // console.log(_this.seller_id)
          _this.brand=_this.taobao_goods.goods_brand;
          _this.store_nick=_this.taobao_goods.store_nick||_this.taobao_goods.shop_info.seller_nick;
          //团长提报目前只支持提报淘宝商品
          _this.platform=_this.taobao_goods.platform;
          _this.file_list = [];
            let json = {
              url: _this.taobao_goods.goods_img||_this.taobao_goods.pict_url
            };
            _this.file_list.push(json);
         //三级分类
          _this.smzdm_category_1 = res.data.smzdm_category_1
            ? res.data.smzdm_category_1
            : "";
          _this.smzdm_category_2 = res.data.smzdm_category_2
            ? res.data.smzdm_category_2
            : "";
          _this.smzdm_category_3 = res.data.smzdm_category_3
            ? res.data.smzdm_category_3
            : "";
          //筛选list
          _this.getList(1, 0);
          if (res.data.smzdm_category_1) {
            _this.categoryLeft(res.data.smzdm_category_1, 1);
          }
          if (res.data.smzdm_category_2) {
            _this.categoryLeft(res.data.smzdm_category_2, 2);
          }

          //只有普通用户需要提示去重优惠券
          if (res.data.goods_exist == 1) {
            _this.coupon = res.data.coupon;
            _this.zk_final_price = _this.taobao_goods.zk_final_price;
            _this.reserve_price = _this.taobao_goods.reserve_price
              ? this.taobao_goods.reserve_price
              : "";
            _this.showrepeat = true;
          }
        } else {
          _this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    //获取优惠券信息
    getCoupon() {
      let _this = this;
      if (this.tao_url == "") {
        this.$message({
          message: "商品链接地址不能为空",
          type: "warning"
        });
        return false;
      }
      if (this.coupon_url == "") {
        this.$message({
          message: "优惠券链接地址不能为空",
          type: "warning"
        });
        return false;
      }
      this.$http({
        method: "POST",
        url: _this.api.getCoupon,
        data: {
          coupon_url: this.coupon_url,
          goods_url: this.tao_url
        }
      }).then(res => {
        if (res.code == 1) {
          // debugger
          this.coupon_start_time = res.data.data.coupon_start_time;
          this.coupon_end_time = res.data.data.coupon_end_time;
          this.coupon_total_count = res.data.data.coupon_total_count;
          this.coupon_remain_count = res.data.data.coupon_remain_count;
          this.coupon_amount = res.data.data.coupon_amount;
          let menkan = Number(res.data.data.coupon_start_fee);
          let yuanjia = Number(_this.taobao_goods.zk_final_price);
          // debugger
          if (yuanjia >= menkan) {
            this.price = util.floatAccSub(
              _this.taobao_goods.zk_final_price,
              res.data.data.coupon_amount
            );
          } else {
            this.price = "";
          }
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    //保存用户提交
    createArticle() {
      let _this = this;
      if (this.suplus <= 0 && this.type == 1) {
        this.$message({
          message: "每人每天最多提报10次",
          type: "warning"
        });
        return false;
      }
      let status = this.getStatus();
      if (status > 0) {
        return false;
      }
      if (this.once == 2) {
        return false;
      }
      this.once = 2;
      // debugger
      this.$http({
        method: "POST",
        url: _this.api.create_article,
        data: {
          goods_out_url: this.tao_url, //淘宝链接
          smzdm_category_1: this.smzdm_category_1, //商品一级分类
          smzdm_category_2: this.smzdm_category_2, //商品二级分类
          smzdm_category_3: this.smzdm_category_3, //商品三级分类
          cat_name: this.taobao_goods.cat_name, //商品一级分类名字
          cat_leaf_name: this.cat_leaf_name, //商品二级分类名字
          goods_brand: this.brand, //商品品牌
          goods_title: this.goods_title, //商品标题
          real_money:this.price, //优惠后价格
          platform: this.platform, //所在商城
          store_nick: this.store_nick, //店铺名称
          seller_id: this.seller_id, //店铺id
          goods_img: this.goods_img ? this.goods_img : this.file_list[0].url,
          is_postage: this.baoyou ? "1" : "0", //是否包邮
          goods_num: this.stock, //库存
          coupon_start_time: this.coupon_start_time, //优惠券开始时间
          coupon_end_time: this.coupon_end_time, //优惠券结束时间
          money_advantage: this.advantage, //价格优势
          goods_advantage: this.goods_advantage, //商品优势
          coupon_name: this.coupon_name, //优惠券名称
          coupon_url: this.coupon_url, //优惠券链接
          coupon_name_2: this.coupon_name_2, //第二章优惠券名称
          coupon_url_2: this.coupon_url_2, //第二张优惠券链接
          cooperation: this.cooperation, //合作方式 1团长活动、2线下结算
          user_commission_rate: this.user_commission_rate, //佣金比例
          settlement_type: this.settlement_type, //结算方式，1按实付金额结算，2按订单量结算
          settlement_rate: this.settlement_rate, //服务费率 （根据settlement_type 为1 时取值 ）
          settlement_free: this.settlement_free, //服务费（根据settlement_type 为2 时取值 ）
          short_extension_title:this.short_extension_title? this.short_extension_title: this.goods_title, //推广短标题
          remark: this.remark, //备注
          check_merchant: this.check_merchant, //是否第一次提交
          coupon_amount: this.coupon_amount, //优惠券价格
          exclusive_discount:_this.exclusive_discount?1:0,//独家优惠
        }
      }).then(res => {
        if (res.code == 1) {
          _this.$message({
            message: "提报成功",
            type: "success",
            duration: 1800
          });
          _this.$router.push({
            name: "singleproduct",
            params: {}
          });
          _this.once = 1;
        } else {
          _this.once = 1;
          // debugger
          if (res.msg == "该店铺已被其他招商绑定") {
            _this.nickname = res[0].data.nickname;
            _this.vip_check_merchant = true;
          }
          _this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      }).catch(err=>{
        _this.once=1;
      })
    },
    //招商进行重复提报
    aginArticle() {
      this.check_merchant = 0;
      this.createArticle();
    },
    //勾选万能模版
    getWanneng(e) {
      if (e) {
        this.advantage = this.wanneng;
      } else {
        this.advantage = "";
      }
    },  
    //重新提一个
    subAgain() {
      this.taobao_goods = {};
      (this.tao_url = ""), (this.file_list = []);
      this.short_extension_title = "";
      this.baoyou = true;
      this.stock = "";
      this.advantage = "";
      this.goods_advantage = "";
      this.showrepeat = false;
      this.brand = "";
      this.goods_title = "";
    },
    //提交更高的优惠券
    subMore() {
      this.showrepeat = false;
    },
    handlePictureCardPreview(file, fileList) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove(file, fileList) {
      this.goods_img = "";
      this.file_list = fileList;
    },
    //图片上传成功了
    fileSuccess(response, file, fileList) {
      // debugger
      let img = new Image();
      img.src = file.url;
      if (img.width != img.height) {
        fileList.pop();
        this.$message({
          message: "请上传正方形图片",
          type: "error"
        });
        return false;
      }
      if (img.width < 400) {
        fileList.pop();
        this.$message({
          message: "请上传宽大于400像素的图片",
          type: "error"
        });
        return false;
      }
      if (img.height < 400) {
        fileList.pop();
        this.$message({
          message: "请上传高大于400像素的图片",
          type: "error"
        });
        return false;
      }
      this.goods_img = file.response.data.pic;
    },
    //图片上传失败
    fileErr(err, file, fileList) {
      this.$message.error("上传失败");
    },
    //文件上传之前
    fileBefore(file) {
      let size = file.size / 1024 / 1024 < 2;
      if (!size) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return false;
      }
    },
    fileChange(file, fileList) {},
    fileExceed(file, fileList) {
      this.$message({
        message: "商品图片限制为一张",
        type: "warning"
      });
    },
    //去到列表页
    goList() {
      this.$router.push({
        name: "singleproduct",
        params: {
          type: this.$route.query.type ? 1 : ""
        }
      });
    },
    //显示弹框
    showLeave() {
      this.leave = true;
    },
    //修改后的提交保存
    editArticle() {
      let _this = this;
      let status = this.getStatus();
      if (status > 0) {
        return false;
      }
      if (this.once == 2) {
        return false;
      }
      this.once = 2;
      this.$http({
        method: "POST",
        url: _this.api.edit_article,
        data: {
          aeid: _this.aeid, //修改的aeid
          aectid:_this.aectid,//文章 article_content表 id
          check_merchant:0,//0 不检测 1 检测 是否店铺绑定用户
          goods_out_url: _this.tao_url, //淘宝链接
          smzdm_category_1:_this.smzdm_category_1,//第一个下拉
          smzdm_category_2:_this.smzdm_category_2,//第二个下拉
          smzdm_category_3:_this.smzdm_category_3,//第三个下拉
          goods_brand: _this.brand, //商品品牌
          goods_title: _this.goods_title, //商品标题
          exclusive_discount:_this.exclusive_discount?1:0,//独家优惠
          real_money:_this.real_money?_this.real_money:_this.price,//优惠后价格
          platform:_this.platform,//所在商城
          store_nick:_this.store_nick,//店铺名称
          goods_img: _this.goods_img ? _this.goods_img : _this.file_list[0].url,//商品图片
          is_postage: _this.baoyou ? "1" : "0", //是否包邮
          goods_num: _this.stock, //库存
          coupon_start_time:_this.coupon_start_time,//优惠券开始时间
          coupon_end_time:_this.coupon_end_time,//优惠券结束时间
          money_advantage: _this.advantage, //价格优势
          goods_advantage: _this.goods_advantage, //商品优势
          coupon_name:_this.coupon_name,
          coupon_name_2:_this.coupon_name_2,
          coupon_url:_this.coupon_url,
          coupon_url_2:_this.coupon_url_2,
          cooperation:_this.cooperation,//合作方式
          user_commission_rate:_this.user_commission_rate,//佣金比例
          settlement_type:_this.settlement_type,//结算方式，1按实付金额结算，2按订单量结算
          settlement_rate:_this.settlement_rate,//服务费率 （根据settlement_type 为1 时取值 ）
          settlement_free:_this.settlement_free,//服务费（根据settlement_type 为2 时取值 
          remark: _this.remark, //备注
          short_extension_title: _this.short_extension_title, //推广短标题
          coupon_amount:_this.coupon_amount,//优惠券金额
        }
      }).then(res => {
        if (res.code == 1) {
          _this.$message({
            message: "提报成功",
            type: "success",
            duration: 1800
          });
          _this.$router.push({
            name: "singleproduct",
            params: {}
          });
          _this.once = 1;
        } else {
          _this.once = 1;
          _this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    //修改某个商品并且获取商品详情
    editSome() {
      let _this = this;
      this.$http({
        method: "POST",
        url: _this.api.getUserArticleInfo,
        data: {
          aeid: _this.aeid
        }
      }).then(res => {
        if (res.code == 1) {
          //招商提报 或者普通提报
            this.tao_url = res.data.goods_out_url;
            this.aectid=res.data.article_content.aectid;//文章 article_content表 id
            this.brand = res.data.goods_brand;
            this.goods_title = res.data.goods_title;
            this.short_extension_title = res.data.short_extension_title;
            this.file_list = [{ url: res.data.goods_img }];
            this.baoyou = res.data.is_postage == 1 ? true : false;
            this.stock = res.data.goods_num;
            this.advantage = res.data.money_advantage;
            this.goods_advantage = res.data.goods_advantage;
            this.goods_title = res.data.goods_title;
            this.price = res.data.real_money;
            // this.real_money=
            //修改商品的时候是否有提交优惠券
            if (res.data.is_have_coupon == 1) {
              this.coupon_url = res.data.coupon_url;
              this.coupon_start_time = res.data.coupon_start_time;
              this.coupon_end_time = res.data.coupon_end_time;
              this.coupon_total_count = res.data.coupon_num_total;
              this.coupon_remain_count = res.data.coupon_num_suplus;
              this.coupon_amount = res.data.coupon_money;
              
              this.remark = res.data.remark;
              this.taobao_goods.zk_final_price = res.data.goods_list_money;
            } else if (res.data.is_have_coupon == 0) {
              this.taobao_goods.zk_final_price = res.data.goods_list_money;
            }
          //三个下拉框
           this.smzdm_category_1 = res.data.smzdm_category_1
              ? res.data.smzdm_category_1
              : "";
            this.smzdm_category_2 = res.data.smzdm_category_2
              ? res.data.smzdm_category_2
              : "";
            this.smzdm_category_3 = res.data.smzdm_category_3
              ? res.data.smzdm_category_3
              : "";
            //筛选list
            this.getList(1, 0);
            if (res.data.smzdm_category_1) {
              this.categoryLeft(res.data.smzdm_category_1, 1);
            }
            if (res.data.smzdm_category_2) {
              this.categoryLeft(res.data.smzdm_category_2, 2);
            }
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    changeTime(num){
      if(num==1){
        
      }else if(num==2){

      }
    },
    getStatus() {
      let _this = this;
      let nums = 0;
        if (!this.tao_url) {
          this.$message({
            message: "商品链接地址不能为空",
            type: "warning"
          });
          nums++;
        } else if (!this.goods_title) {
          this.$message({
            message: "商品标题不能为空",
            type: "warning"
          });
          nums++;
        } else if (!this.short_extension_title) {
          this.$message({
            message: "推广短标题不能为空",
            type: "warning"
          });
          nums++;
        } else if (!this.file_list.length && !_this.goods_img) {
          this.$message({
            message: "商品图片不能为空",
            type: "warning"
          });
          nums++;
        } else if (!this.stock) {
          this.$message({
            message: "商品库存不能为空",
            type: "warning"
          });
          nums++;
        } else if (!this.advantage) {
          this.$message({
            message: "价格优势不能为空",
            type: "warning"
          });
          nums++;
        } else if (this.advantage.length < 7) {
          this.$message({
            message: "价格优势最少输入7个字",
            type: "warning"
          });
          nums++;
        } else if (!this.goods_advantage) {
          this.$message({
            message: "商品优势不能为空",
            type: "warning"
          });
          nums++;
        } else if (this.goods_advantage.length < 7) {
          this.$message({
            message: "商品优势最少填写7个字",
            type: "warning"
          });
          nums++;
        } else if (this.coupon_url && !this.price) {
          this.$message({
            message: "优惠后价格不能为空",
            type: "warning"
          });
          nums++;
        }else if(!this.price){
          this.$message({
            message: "优惠后价格不能为空",
            type: "warning"
          });
          nums++;
        }
      
      return nums;
    },
    couponShow() {
      this.coupon_show = true;
      this.coupon_add = false;
    },
    couponHide() {
      this.coupon_name_2 = "";
      this.coupon_url_2 = "";
      this.coupon_show = false;
      this.coupon_add = true;
    },
    getLement(e) {
      this.settlement_rate_1 = e;
      if (e == 1) {
        this.settlement_free = "";
      } else if (e == 2) {
        this.settlement_rate = "";
      }
    },
    getSlect() {
      console.log(this.smzdm_category_1);
    },
    //百分号和小数点互转
    getBaifen(num,way){
      let nums='';
      if(way==1){
        console.log(num.slice(0,num.length-1))
        nums=(Number(num.slice(0,num.length-1))/100).toFixed(4)
      }else if(way==2){
        nums=(((Number(num) * 10000))/100).toFixed(4);
        nums=Number(nums)+'%'
      }
      return nums;
    }
  },

  destroyed() {
    sessionStorage.setItem("setType", 1);
  }
};
</script>
<style  scoped>
.is-icon {
  height: 0;
}
.up-img {
  height: 114px;
  background: #f4f4f4;
  border-radius: 2px;
  padding-left: 11px;
}
.jiao {
  position: absolute;
  top: 22px;
  width: 50px;
  height: 18px;
  text-align: center;
  background: #e5324d;
  z-index: 1000000;
  border-radius: 6px 3px 3px 3px;
  opacity: 0.9;
}
.sub-add {
  font-size: 28px;
  color: #f56c6c;
}
.over-hid{
  overflow: hidden;
}
.line-40{
  line-height:40px;
}
</style>